import React from 'react';
import { Button, Form, Table } from 'react-bootstrap';

export const parseDoiTuongMienGiam = (value) => {
    if (!value || typeof value !== 'string') return [];

    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
            return parsed.map(item => ({
                tenDoiTuong: typeof item === 'string'
                    ? item
                    : item.tenDoiTuong ?? item.TenDoiTuong ?? ''
            })).filter(item => item.tenDoiTuong.trim());
        }
    } catch (_) {
        // Hỗ trợ dữ liệu cũ được lưu dạng mỗi đối tượng một dòng hoặc phân cách bằng dấu chấm phẩy.
    }

    return value.split(/\r?\n|;/)
        .map(item => ({ tenDoiTuong: item.trim() }))
        .filter(item => item.tenDoiTuong);
};

export const stringifyDoiTuongMienGiam = (items) => JSON.stringify(
    items.map(item => item.tenDoiTuong.trim())
);

const DoiTuongMienGiamFields = ({ values, errors, setFieldValue }) => {
    const danhSach = values.doiTuongMienGiams || [];
    const danhSachErrors = errors.doiTuongMienGiams || [];

    const handleToggle = (event) => {
        const checked = event.target.checked;
        setFieldValue('coDoiTuongMienGiam', checked);
        setFieldValue('doiTuongMienGiams', checked && danhSach.length === 0 ? [{ tenDoiTuong: '' }] : danhSach);
    };

    const handleAdd = () => {
        setFieldValue('doiTuongMienGiams', [...danhSach, { tenDoiTuong: '' }]);
    };

    const handleRemove = (index) => {
        const next = danhSach.filter((_, itemIndex) => itemIndex !== index);
        setFieldValue('doiTuongMienGiams', next.length > 0 ? next : [{ tenDoiTuong: '' }]);
    };

    return (
        <Form.Group className="mb-3">
            <Form.Check
                type="checkbox"
                id="coDoiTuongMienGiam"
                name="coDoiTuongMienGiam"
                checked={values.coDoiTuongMienGiam}
                onChange={handleToggle}
                label="Có đối tượng miễn giảm"
                custom
            />

            {values.coDoiTuongMienGiam && (
                <div className="mt-3">
                    <Table bordered responsive className="mb-2">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: '180px' }}>Đối tượng</th>
                                <th>Tên đối tượng</th>
                                <th style={{ width: '70px' }} className="text-center">Xóa</th>
                            </tr>
                        </thead>
                        <tbody>
                            {danhSach.map((item, index) => (
                                <tr key={item.id || item.Id || index}>
                                    <td className="align-middle">Đối tượng {index + 1}</td>
                                    <td>
                                        <Form.Control
                                            type="text"
                                            value={item.tenDoiTuong ?? item.TenDoiTuong ?? ''}
                                            placeholder={`Nhập tên đối tượng ${index + 1}`}
                                            onChange={(event) => setFieldValue(
                                                `doiTuongMienGiams.${index}.tenDoiTuong`,
                                                event.target.value
                                            )}
                                            isInvalid={!!danhSachErrors[index]?.tenDoiTuong}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {danhSachErrors[index]?.tenDoiTuong}
                                        </Form.Control.Feedback>
                                    </td>
                                    <td className="text-center align-middle">
                                        <Button variant="outline-danger" size="sm" type="button" onClick={() => handleRemove(index)}>
                                            <i className="fas fa-trash"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Button variant="outline-primary" size="sm" type="button" onClick={handleAdd}>
                        <i className="fas fa-plus mr-1"></i> Thêm đối tượng
                    </Button>
                </div>
            )}
        </Form.Group>
    );
};

export default DoiTuongMienGiamFields;
